module.exports = __webpack_public_path__ + "static/media/invaluable.a102d508.png";